import './gallery.scss'

function init() {
    console.log("gallery.js");
}
export default init

export function gallery(block) {
    console.log("gallery", block);
    
}


// import {
//     pad
//   } from '../../utilities/helpers';
  
//   import {
//     mediaOrientation
//   } from '../../utilities/mediaorientation';
  
//   import {
//     hoverNav
//   } from '../../utilities/hovernav';
  
//   export function slideshow($block, isadmin) {
  
//     // IM USING JQUERY HERE - so stick with that and don't swayinto using vanilla as well!
//     var $ = $ || jQuery; // added to see solve jquery issue
//     // console.log("$", $);
//     if (isadmin == true) {
//       // console.log("admin == true:", isadmin);
//     } else {
//       // console.log("admin == false:", isadmin);
//     };
//     var flickityoptions = {
//         imagesLoaded: true,
//         setGallerySize: false, // use my css
//         // setGallerySize: true, //if you prefer to size the carousel with CSS, rather than using the size of cells.
//         pageDots: false,
//         // default cellAlign: 'center'
//         // percentPosition: false, 
//         freeScroll: false,
//         wrapAround: true,
//         prevNextButtons: false,
//         cellAlign: 'left'
  
//       },
//       $thisslideshow = $block.find(".slideshow__carousel"),
//       $thisslideshowcounter = $block.find('.slideshow__counter'),
//       $navPrevious = $block.find('.slideshow__navigation-left'),
//       $navDrag = $thisslideshow,
//       $navNext = $block.find('.slideshow__navigation-right');
  
//     $thisslideshow.on('ready.flickity', function () {
  
//       // console.log("on ready flickity");
  
//       var $slideshow = $(this),
//         $imageslides = $(this).find("[data-slide-type='image'] .image__wrap"), // this  DOEENST covers videos aswell
//         flkty = Flickity.data($(this)[0]);
  
//       flkty.focus(); // focus for keyboard nav
  
//       $slideshow.imagesLoaded({ // images loaded already applie dby flicity
//           // options...
//         },
//         function () {
//           // console.log("imageloaded apply media orientation");
//           // mediaOrientation($thisitem, thisimagewidth, thisimageheight);
//           //this is bit messay - but it works; 
//           runMediaOrientation($imageslides, $slideshow);
//           $slideshow.flickity('resize'); //tesst - 
//           runMediaOrientation($imageslides, $slideshow);
//           setStatus(flkty, $thisslideshowcounter);
//         }
//       );
  
//       if ($('body').hasClass("is-not-touch")) {
//         // hovernav($thisslideshow);
//         // hoverNav($thisslideshow, $navPrevious, $navDrag, $navNext)
  
//         if (isadmin == true) {
//           // console.log("admin == true", isadmin);
//         } else {
//           // console.log("admin == ", isadmin);
//           // runMediaOrientation($imageslides);
//         //   hoverNav($slideshow, $navPrevious, $navDrag, $navNext)
//         };
  
//       }
  
//       // previous
//       $navPrevious.on('click', function () {
//         // console.log("previous item click");
//         $slideshow.flickity('previous').focus();
//       });
//       // next
//       $navNext.on('click', function () {
//         // console.log("mext item click");
//         $slideshow.flickity('next').focus();
//       });
  
//       $slideshow.on('change.flickity', function (event, index) {
  
//         // console.log('on change.flickity');
//         var $slideshow = $(this),
//           flkty = $slideshow.data('flickity');
//         // console.log('flkty', flkty);
//         // console.log('carousel at ' + flkty.selectedIndex);
//         runMediaOrientation($imageslides, $slideshow);
//         updateStatus(flkty, $thisslideshowcounter); // run initall update counter as well
//       });
  
//       $(window).on('resize', function () {
  
//         $thisslideshow.flickity('resize');
//         runMediaOrientation($imageslides, $slideshow);
//       }); // $(window).on('resize', function()
  
//     }); //$thisslideshow.on('ready.flickity', function()
  
//     function runMediaOrientation($imageslides, $slideshow) {
  
//       $imageslides.each(function () {
//         // console.log("imageslides aech");
//         var $thisitem = $(this),
//           thisimagewidth,
//           thisimageheight;
//         mediaOrientation($thisitem, thisimagewidth, thisimageheight);
//       });
  
//     }
  
//     function setStatus(flkty, $thisslideshowcounter) {
//       // console.log("thisslideshow", flkty);
//       if (flkty.slides) {
//         var total = pad(flkty.slides.length, 3);
//         $thisslideshowcounter.find('.counter__total').text(total);
//         updateStatus(flkty, $thisslideshowcounter); // run initall update counter as well
//       }
  
//     } //setStatus()
  
//     function updateStatus(flkty, $thisslideshowcounter) {
//       // console.log("updateStatus()");
//       var slideNumber = pad(flkty.selectedIndex + 1, 3);
//       $thisslideshowcounter.find('.counter__current').text(slideNumber);
//     }
  
//     // intialiase flickitys
//     $thisslideshow.flickity(flickityoptions);
  
//   } //export function slideshow($block){